import { ISelectOption } from "@common/components/forms/";
import { IModel, ISpeciesModel, Model } from "@common/models";
import { SpeciesModel } from "./SpeciesModel";

export interface IAppointmentTypeRequest extends IModel {
    authApplicationId: number
    name: string
    species: Array<ISpeciesModel>
    color: string
    description: string
    defaultDurationSeconds: number
    onlineBooking: boolean,
    isSurgery: boolean,
    isDropoff: boolean,
    isActive: boolean,
    isLocked: boolean
}

export interface IAppointmentTypeModel extends IAppointmentTypeRequest {
    appointmentTypeId: number,
}

export class AppointmentTypeModel extends Model implements IAppointmentTypeModel {
    authApplicationId: number;
    appointmentTypeId: number;
    name: string;
    species: ISpeciesModel[];
    color: string;
    description: string;
    defaultDurationSeconds: number;
    onlineBooking: boolean;
    isSurgery: boolean;
    isDropoff: boolean;
    isActive: boolean;
    isLocked: boolean;

    constructor(params: IAppointmentTypeModel) {
        super(params);
        this.authApplicationId = params.authApplicationId;
        this.appointmentTypeId = params.appointmentTypeId;
        this.name = params.name;
        this.species = params.species && params.species.map(s => new SpeciesModel(s));
        this.color = params.color;
        this.description = params.description;
        this.defaultDurationSeconds = params.defaultDurationSeconds;
        this.onlineBooking = params.onlineBooking;
        this.isSurgery = params.isSurgery;
        this.isDropoff = params.isDropoff;
        this.isActive = params.isActive;
        this.isLocked = params.isLocked;
    }
}

export const AppointmentDurationOptions: ISelectOption[] & { disabled?: boolean } = [
    { value: 900, label: "15 minutes" },
    { value: 1800, label: "30 minutes" },
    { value: 2700, label: "45 minutes" },
    { value: 3600, label: "1 hour" },
    { value: 5400, label: "1 hour 30 minutes" },
    { value: 7200, label: "2 hours" },
    { value: 9000, label: "2 hours 30 minutes" },
    { value: 10800, label: "3 hours" }
]
